import React,{useState} from 'react';
import { Button, Form } from 'react-bootstrap';
import Layout from '../../layout/layout';
// import tower from '../../../assets/images/game/tower.svg';
import singelgem from '../../../assets/images/header/gem.png';
import coin from '../../../assets/images/header/gem.png';
import './tower.css';
import DiceHistory from '../dice/history';
import gemicon from '../../../assets/images/mines/gemicon.svg'

const Tower = () => {
  const[btn, setBtn]=useState('easy');
  const handleToggle = (arg) => {
  setBtn(arg)
  };
  
  return (
    <Layout>
      <div className='tower-page'>
        <div className='container'>
          <div className='tower-title'>
            {/* ******For Tower Main Heading Start******* */}

            {/* <div className='tower-heading'>
              <h2>
                <img src={tower} alt='tower' />
                Tower
              </h2>
            </div> */}

            {/* ******For Tower Main Heading End******* */}

            {/* ******For Cash Out Heading Start******* */}

            <div className='cash-out'>
            <div class="triangle triangle1 triangle-6"></div>
              <h2>
                Cashout at
                <img src={singelgem} alt='gem' />
                <span>10.59</span>
              </h2>
              <div class="triangle triangle2 triangle-6"></div>
              <div class="triangle triangle3 triangle-6"></div>
            </div>

            {/* ******For Cash Out Heading End******* */}

            {/* ******For You Lost Heading Start******* */}

            {/* <div className='tower-lost'>
              <h2>
                You lost
                <img src={singelgem} alt='gem' />
                <span>10.59</span>
              </h2>
            </div> */}

            {/* ******For You Lost Heading End******* */}
          </div>

          <div className='tower-body'>
            <div className='tower-main-box winner-tower-game'>
              <div className='tower-list-row'>
              <div className='tower-box'>
                <h6>
                  <img src={singelgem} alt='gem' />
                  100.43
                </h6>
              </div>
              <div className='tower-box'>
                <h6>
                  <img src={singelgem} alt='gem' />
                  100.43
                </h6>
              </div>
              <div className='tower-box'>
                <h6>
                  <img src={singelgem} alt='gem' />
                  100.43
                </h6>
              </div>
              </div>
              <div className='tower-list-row'>
              <div className='tower-box'>
                <h6>
                  <img src={singelgem} alt='gem' />
                  69.03
                </h6>
              </div>
              <div className='tower-box'>
                <h6>
                  <img src={singelgem} alt='gem' />
                  69.03
                </h6>
              </div>
              <div className='tower-box'>
                <h6>
                  <img src={singelgem} alt='gem' />
                  69.03
                </h6>
              </div>
              </div>
              <div className='tower-list-row'>
              <div className='tower-box'>
                <h6>
                  <img src={singelgem} alt='gem' />
                  47.44
                </h6>
              </div>
              <div className='tower-box'>
                <h6>
                  <img src={singelgem} alt='gem' />
                  47.44
                </h6>
              </div>
              <div className='tower-box'>
                <h6>
                  <img src={singelgem} alt='gem' />
                  47.44
                </h6>
              </div>
              </div>
              <div className='tower-list-row'>
              <div className='tower-box'>
                <h6>
                  <img src={singelgem} alt='gem' />
                  32.61
                </h6>
              </div>
              <div className='tower-box'>
                <h6>
                  <img src={singelgem} alt='gem' />
                  32.61
                </h6>
              </div>
              <div className='tower-box'>
                <h6>
                  <img src={singelgem} alt='gem' />
                  32.61
                </h6>
              </div>
              </div>
              <div className='tower-list-row'>
              <div className='tower-box'>
                <h6>
                  <img src={singelgem} alt='gem' />
                  22.41
                </h6>
              </div>
              <div className='tower-box'>
                <h6>
                  <img src={singelgem} alt='gem' />
                  22.41
                </h6>
              </div>
              <div className='tower-box'>
                <h6>
                  <img src={singelgem} alt='gem' />
                  22.41
                </h6>
              </div>
              </div>
              <div className='tower-list-row'>
              <div className='tower-box'>
                <h6>
                  <img src={singelgem} alt='gem' />
                  15.40
                </h6>
              </div>
              <div className='tower-box'>
                <h6>
                  <img src={singelgem} alt='gem' />
                  15.40
                </h6>
              </div>
              <div className='tower-box'>
                <h6>
                  <img src={singelgem} alt='gem' />
                  15.40
                </h6>
              </div>
              </div>
              <div className='tower-list-row winner-tower-row'>
              <div className='tower-box'>
                <h6>
                  <img src={singelgem} alt='gem' />
                  10.59
                </h6>
              </div>
              <div className='tower-box'>
                <h6>
                  <img src={singelgem} alt='gem' />
                  10.59
                </h6>
              </div>
              <div className='tower-box'>
                <h6>
                  <img src={singelgem} alt='gem' />
                  10.59
                </h6>
              </div>
              </div>
              <div className='tower-list-row'>
              <div className='tower-box'>
                <h6>
                  <img src={singelgem} alt='gem' />
                  7.28
                </h6>
              </div>
              <div className='tower-box'>
                <h6>
                  <img src={singelgem} alt='gem' />
                  7.28
                </h6>
              </div>
              <div className='tower-box winner-tower-box'>
                <h6>
                  <img src={gemicon} alt='gem' />
                  {/* 7.28 */}
                </h6>
              </div>
              </div>
            </div>

            <div className='tower-bet-box'>
              <div className='roll-dice'>
                <Button>PLACE BET </Button>
              </div>
              <Form>
                <Form.Group>
                  <Form.Label>Bet Amount</Form.Label>
                  <div className='bet-input pdd-200'>
                    <img src={coin} alt='gem' />
                    <Form.Control type='number' placeholder='58.52' />
                    <div className='bet-input-btn'>
                      <Button>1/2</Button>
                      <Button>2x</Button>
                      <Button>Max</Button>
                    </div>
                  </div>
                </Form.Group>
              </Form>
              <div className='level-btn'>
                <Button onClick={()=>handleToggle('easy') } className={`${btn==='easy' && "active-level-btn"}`}>Easy</Button>
                <Button onClick={()=>handleToggle('medium') } className={`${btn==='medium' && "active-level-btn"}`} >Medium</Button>
                <Button onClick={()=>handleToggle('hard') } className={`${btn==='hard' && "active-level-btn"}`}>Hard</Button>
                {/* <ButtonGroup>
                  <ToggleButton
                    id='1'
                    type='radio'
                    className={`.btn-check ${
                      radioValue === '1' ? 'outline-success' : 'outline-danger'
                    }`}
                    name='radio'
                    value='1'
                    checked={radioValue === '1'}
                    onChange={(e) => setRadioValue(e.target.value)}
                  >
                    Easy
                  </ToggleButton>
                  <ToggleButton
                    id='2'
                    type='radio'
                    className={`.btn-check ${
                      radioValue === '1' ? 'outline-success' : 'outline-danger'
                    }`}
                    name='radio'
                    value='2'
                    checked={radioValue === '2'}
                    onChange={(e) => setRadioValue(e.target.value)}
                  >
                    Medium
                  </ToggleButton>
                  <ToggleButton
                    key=''
                    id='3'
                    type='radio'
                    className={`.btn-check ${
                      radioValue === '1' ? 'outline-success' : 'outline-danger'
                    }`}
                    name='radio'
                    value='3'
                    checked={radioValue === '3'}
                    onChange={(e) => setRadioValue(e.target.value)}
                  >
                    Hard
                  </ToggleButton>
                </ButtonGroup> */}
              </div>
            </div>
            <div className='change-seed'>
              <Button>Change Seeds</Button>
            </div>
          </div>
          <DiceHistory />
        </div>
      </div>
    </Layout>
  );
};

export default Tower;
